module.exports = __webpack_public_path__ + "img/chevrone-down.6c0f52d4.svg";